import { createClient } from '@supabase/supabase-js'
import { VITE_11_SUPABASE_URL, VITE_11_SUPABASE_ANON_KEY } from '@/core/constants/env'

if (!VITE_11_SUPABASE_URL || !VITE_11_SUPABASE_ANON_KEY) {
  throw new Error('Supabase URL and Key must be provided')
}

export const supabase = createClient(VITE_11_SUPABASE_URL, VITE_11_SUPABASE_ANON_KEY)
  